import BlogOneContainer from "./container/BlogOneContainer";
export default BlogOneContainer;
